import { createContext, useContext } from "react";

import type { ICookiesProvider } from "./ICookiesProvider";

// created such that you will always have a value for context
export const CookiesContext = createContext<ICookiesProvider>({} as never);

export const useCookiesProvider = (): ICookiesProvider => useContext(CookiesContext);
